import { render, staticRenderFns } from "./reportLost.vue?vue&type=template&id=b96bce30&scoped=true"
var script = {}
import style0 from "./reportLost.vue?vue&type=style&index=0&id=b96bce30&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96bce30",
  null
  
)

export default component.exports